export default __webpack_public_path__ + "static/media/StefWongProfilePicture2020.e098b8f3.jpg";